/* SVADEZI: selected Shopify price and recorded breakdown only. No repricing.
 * The inline breakdown is always open. Stale responses cannot replace a newer
 * selection, and a failed same-variant refresh cannot erase its valid record.
 */
(function () {
  'use strict';
  var form = document.getElementById('pdp-form');
  if (!form) return;
  var sel = form.querySelector('[data-variant-select]');
  if (!sel) return;
  var priceEl = document.querySelector('[data-price]');
  var emiEl = document.querySelector('[data-emi]');
  var stickyPrice = document.querySelector('.pdp-sticky-price .p');
  var bdHost = document.querySelector('[data-bd2-host]');
  var variants = window.__pdpVariants || [];
  var priceSeq = 0;

  function integer(value) {
    var text = String(value);
    if (!/^\d+$/.test(text)) return null;
    var number = Number(text);
    return Number.isSafeInteger(number) ? number : null;
  }
  function money(paise) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: 'INR',
      minimumFractionDigits: 0, maximumFractionDigits: 2
    }).format(paise / 100);
  }
  function paintPrice(paise) {
    if (priceEl) priceEl.textContent = money(paise);
    if (emiEl) emiEl.textContent = money(Math.round(paise / 12)) + '/mo';
    if (stickyPrice) stickyPrice.textContent = money(paise);
  }
  function currentRecord(id, paise) {
    if (!bdHost) return null;
    var item = bdHost.querySelector('[data-bd3-variant-id]');
    if (!item || item.getAttribute('data-bd3-variant-id') !== String(id)) return null;
    if (paise !== null && integer(item.getAttribute('data-bd3-shopify-total')) !== paise) return null;
    return item;
  }
  function notice(id, paise, message, state) {
    if (!bdHost) return;
    var box = document.createElement('section');
    box.className = 'pdp-bd svz-bd3-inline';
    box.setAttribute('aria-label', 'Price breakdown');
    box.setAttribute('data-bd3-variant-id', String(id || ''));
    box.setAttribute('data-bd3-shopify-total', paise === null ? '' : String(paise));
    box.setAttribute('data-bd3-migrated', 'false');
    box.setAttribute('data-bd3-reason', state);
    var heading = document.createElement('h2');
    heading.className = 'pdp-bd-h';
    heading.textContent = 'Price breakdown';
    var text = document.createElement('p');
    text.className = 'pdp-bd-note';
    text.textContent = message;
    box.appendChild(heading);
    box.appendChild(text);
    if (paise !== null) {
      var total = document.createElement('div');
      total.className = 'pdp-bd-total';
      var label = document.createElement('span');
      label.textContent = 'Total item price';
      var value = document.createElement('b');
      value.textContent = money(paise);
      total.appendChild(label);
      total.appendChild(value);
      box.appendChild(total);
    }
    bdHost.replaceChildren(box);
  }
  function syncHallmark(root) {
    var marker = root && root.querySelector('[data-bd2-metal]');
    var metal = marker && marker.getAttribute('data-bd2-metal');
    if (metal !== 'gold' && metal !== 'silver') return;
    document.querySelectorAll('[data-svz-hallmark]').forEach(function (item) {
      item.textContent = metal === 'silver' ? '925-stamped silver' : 'BIS-hallmarked gold';
    });
    document.querySelectorAll('[data-svz-hallmark-short]').forEach(function (item) {
      item.textContent = metal === 'silver' ? '925' : 'BIS';
    });
  }
  function setAtc(available) {
    var atc = form.querySelector('.pdp-atc');
    if (!atc) return;
    atc.disabled = !available;
    var label = atc.querySelector('.lbl');
    if (label) label.textContent = available ? 'Add to bag' : 'Sold out';
  }
  function fetchAuthoritativePrice(id, knownPaise) {
    id = String(id);
    var seq = ++priceSeq;
    if (!currentRecord(id, knownPaise)) {
      notice(id, knownPaise, 'Loading the itemised price for this option...', 'loading');
    }
    if (knownPaise === null) {
      if (priceEl) priceEl.textContent = '\u2014';
      if (stickyPrice) stickyPrice.textContent = '\u2014';
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    url.searchParams.set('section_id', 'variant-price');
    url.searchParams.delete('sections');
    function isCurrent() { return seq === priceSeq && String(sel.value) === id; }
    function failed() {
      if (!isCurrent()) return;
      var saved = currentRecord(id, knownPaise);
      if (saved && saved.getAttribute('data-bd3-migrated') === 'true') return;
      notice(id, knownPaise,
        'The itemised breakdown could not be loaded. Please reload this page to check this option.',
        'section-request-failed');
    }
    fetch(url.pathname + url.search, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Section request failed');
        return response.text();
      })
      .then(function (html) {
        if (!isCurrent()) return;
        var root = document.createElement('div');
        root.innerHTML = html;
        var marker = root.querySelector('[data-svz-variant-id]');
        var payload = root.querySelector('[data-svz-bd-payload]');
        if (!marker || !payload || marker.getAttribute('data-svz-variant-id') !== id) {
          failed(); return;
        }
        var paise = integer(marker.getAttribute('data-svz-variant-price'));
        var record = payload.querySelector('[data-bd3-variant-id]');
        if (paise === null || !record || record.getAttribute('data-bd3-variant-id') !== id ||
            integer(record.getAttribute('data-bd3-shopify-total')) !== paise) {
          failed(); return;
        }
        paintPrice(paise);
        setAtc(marker.getAttribute('data-svz-variant-available') === 'true');
        if (bdHost) {
          bdHost.innerHTML = payload.innerHTML;
          var details = bdHost.querySelector('details.pdp-bd');
          if (details && details.getAttribute('data-bd3-migrated') === 'true') {
            details.open = true;
          }
        }
        syncHallmark(root);
      })
      .catch(failed);
  }
  function chosen() {
    return Array.prototype.map.call(form.querySelectorAll('.opt'), function (group) {
      var control = group.querySelector('input[type=radio]:checked, select');
      return control ? control.value : null;
    });
  }
  function syncVariant() {
    var picked = chosen();
    if (picked.some(function (value) { return value === null; })) return;
    var match = variants.filter(function (variant) {
      return picked.every(function (value, index) { return variant.options[index] === value; });
    })[0];
    if (match) {
      sel.value = String(match.id);
      var paise = integer(match.price);
      if (paise !== null) paintPrice(paise);
      setAtc(match.available);
      fetchAuthoritativePrice(match.id, paise);
      return;
    }
    var matrix = window.SvadeziVariants;
    var id = matrix && matrix.available() ? matrix.id(picked) : null;
    if (id) {
      sel.value = String(id);
      setAtc(false);
      fetchAuthoritativePrice(id, null);
      return;
    }
    priceSeq++;
    sel.value = '';
    setAtc(false);
    if (priceEl) priceEl.textContent = '\u2014';
    if (stickyPrice) stickyPrice.textContent = '\u2014';
    notice('', null, 'Choose an available option to see its price breakdown.', 'unavailable-variant');
    var atcLabel = form.querySelector('.pdp-atc .lbl');
    if (atcLabel) atcLabel.textContent = 'Unavailable';
  }
  form.addEventListener('change', function (event) {
    if (event.target.matches('.opt-row input[type=radio], .opt-row select')) syncVariant();
  });
  window.SvadeziSyncVariant = syncVariant;
})();
